import React from 'react';
import { Outlet } from 'react-router-dom';
import AccessDeniedCard from '../../../components/AccessDeniedCard';
import { usePermissions } from '../../../hooks/usePermissions';
import { useRoleModuleLabel } from '../../../hooks/useRoleModuleLabel';
import {
  READ_BULK_UPLOAD,
  READ_CUSTOMER,
  READ_PRODUCT,
  READ_SALE_CREDIT_NOTE,
  READ_SALE_INVOICE,
} from '../../../constants/eInvoicePermissions';
import { BULK_UPLOAD_MODULE_KEY } from '../../settings/constants/roleModules';

export default function SalesBulkUploadAccessLayout() {
  const { loading, hasEInvoicePermission } = usePermissions();
  const title = useRoleModuleLabel(BULK_UPLOAD_MODULE_KEY);

  if (loading) {
    return null;
  }

  const canReadSales = hasEInvoicePermission(READ_SALE_INVOICE) || hasEInvoicePermission(READ_SALE_CREDIT_NOTE);
  const canReadCustomer = hasEInvoicePermission(READ_CUSTOMER);
  const canReadProduct = hasEInvoicePermission(READ_PRODUCT);
  const isAllowed = hasEInvoicePermission(READ_BULK_UPLOAD) && (canReadSales || canReadCustomer || canReadProduct);

  if (!isAllowed) {
    return <AccessDeniedCard title={title} />;
  }

  return <Outlet />;
}
